import { LocalStorage } from 'quasar'
import { general as generalConfig } from 'src/config'
import store from 'src/store'

export default [
  {
    path: '/',
    component: () => import('layouts/default'),
    name: 'base',
    beforeEnter: (to, from, next) => {
      let url = LocalStorage.get.item('redirect_url')
      if (url) {
        LocalStorage.remove('redirect_url')
        return next(url)
      }

      if (to.name !== 'base') {
        return next()
      }

      if (store.getters.activeTeam) {
        return next(`/${store.getters.activeTeam.id}/dashboard`)
      }

      return next('/team/new')
    },
    children: [
      { path: '/:teamId/dashboard', name: 'dashboard', component: () => import('pages/Dashboard') },
      { path: '/:teamId/invoices', name: 'invoices', component: () => import('pages/invoices/Invoices') },
      { path: '/:teamId/pending-invoice-imports', name: 'pending-invoice-imports', component: () => import('pages/invoices/PendingInvoiceImports') },
      { path: '/:teamId/invoices/create', name: 'create-invoice', meta: { roleRequired: true, role: 2 }, component: () => import('pages/invoices/CreateInvoice') },
      { path: '/:teamId/invoices/:invoice', name: 'invoice', component: () => import('pages/invoices/Invoice') },
      { path: '/:teamId/invoices/:invoice/edit', name: 'edit-invoice', meta: { roleRequired: true, role: 2 }, component: () => import('pages/invoices/CreateInvoice') },
      { path: '/:teamId/quotes', name: 'quotes', component: () => import('pages/quotes/Quotes') },
      { path: '/:teamId/quotes/create', name: 'create-quote', meta: { roleRequired: true, role: 2 }, component: () => import('pages/quotes/CreateQuote') },
      { path: '/:teamId/quotes/:quote', name: 'quote', component: () => import('pages/quotes/Quote') },
      { path: '/:teamId/quotes/:quote/edit', name: 'edit-quote', meta: { roleRequired: true, role: 2 }, component: () => import('pages/quotes/CreateQuote') },
      { path: '/:teamId/reports', name: 'reports', component: () => import('pages/Reports') },
      { path: '/:teamId/items', name: 'items', component: () => import('pages/items/Items') },
      { path: '/settings', name: 'settings', component: () => import('pages/Settings') },
      {
        path: '/:teamId/customers',
        name: 'customers',
        component: () => import('pages/customers/Customers'),
        children: [
          {
            name: 'customer',
            path: '/:teamId/customers/:customerId',
            component: () => import('pages/customers/Customer')
          }
        ]
      },
      { path: '/:teamId/customers/person/create', name: 'create-person', component: () => import('pages/customers/Customers') },
      { path: '/:teamId/customers/company/create', name: 'create-company', component: () => import('pages/customers/Customers') },
      {
        path: '/team/:teamId/settings',
        name: 'team-settings',
        meta: { roleRequired: true, role: 1 },
        component: () => import('pages/team/TeamSettings'),
        props: true
      },
      {
        name: 'time-tracking',
        path: '/:teamId/time-tracking',
        meta: { timeTracking: true },
        component: () => import('pages/timetracking/TimeTracking')
      },
      {
        name: 'time-entries',
        path: '/:teamId/time-tracking/entries',
        meta: { timeTracking: true },
        component: () => import('pages/timetracking/TimeEntries')
      },
      {
        name: 'projects',
        path: '/:teamId/projects',
        component: () => import('pages/timetracking/Projects')
      },
      {
        name: 'project',
        path: '/:teamId/projects/:project',
        component: () => import('pages/timetracking/Project')
      },
      { path: '/:teamId/expenses', name: 'expenses-dashboard', component: () => import('pages/expenses/ExpensesDashboard'), meta: { expenses: true } },
      { path: '/:teamId/expenses/list', name: 'expenses-list', component: () => import('pages/expenses/Expenses'), meta: { expenses: true } },
      { path: '/:teamId/expenses/capture', name: 'capture-expenses', component: () => import('pages/expenses/CaptureExpenses'), meta: { expenses: true } },
      { path: '/:teamId/expenses/:expenseId', name: 'expense', component: () => import('pages/expenses/Expense'), meta: { expenses: true } },
      {
        path: '/:teamId/finances', name: 'finances', component: () => import('pages/finances/Finances')
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('layouts/auth'),
    name: 'auth',
    children: [
      { path: '/login', name: 'login', meta: { guestsOnly: true }, component: () => import('pages/auth/Login') },
      { path: '/tfa', name: 'two-factor', meta: { guestsOnly: true }, component: () => import('pages/auth/TwoFactor') },
      {
        path: '/register',
        name: 'register',
        meta: { guestsOnly: true },
        component: () => import('pages/auth/Register')
      },
      {
        path: '/forgot',
        name: 'forgot-password',
        meta: { guestsOnly: true },
        component: () => import('pages/auth/ForgotPassword')
      },
      {
        path: '/reset/:token',
        meta: { guestsOnly: true },
        component: () => import('pages/auth/ResetPassword'),
        props: true
      },
      { path: '/verify/:token', meta: { guestsOnly: true }, component: () => import('pages/auth/VerifyAccount') },
      {
        path: '/email/confirm/:token',
        name: 'confirm-email',
        meta: { unprotected: true },
        component: () => import('pages/user/ConfirmEmail'),
        props: true
      },
      {
        path: '/team/delete/:token',
        name: 'confirm-team-delete',
        meta: { unprotected: true },
        component: () => import('pages/team/ConfirmDelete'),
        props: true
      },
      {
        path: '/user/delete/:token',
        name: 'confirm-user-delete',
        meta: { unprotected: true },
        component: () => import('pages/user/ConfirmDelete'),
        props: true
      },
      {
        path: '/confirm-payment/:payment',
        name: 'confirm-payment',
        meta: { unprotected: true },
        component: () => import('pages/billing/ConfirmPayment'),
        props: true
      }
    ]
  },
  { path: '/team/new', name: 'new-team', component: () => import('pages/team/NewTeam') },
  {
    path: '/invite/:token',
    name: 'accept-invite',
    meta: { unprotected: true },
    component: () => import('pages/team/AcceptInvite'),
    props: true
  },
  {
    path: '/beta-redirect',
    name: 'beta-redirect',
    meta: { unprotected: true },
    beforeEnter (to, from, next) {
      if (LocalStorage.has('token') || LocalStorage.has('localSettings')) {
        return next('/')
      } else {
        location.href = generalConfig.beta_link
      }
    }
  },
  { path: '/403', name: '403', component: () => import('pages/403') },
  { path: '*', name: '404', meta: { unprotected: true }, component: () => import('pages/404') } // Not found
]
